export type NetworkId = 'eos-mainnet'
// Add more chains here as we scale: 'wax-mainnet' | 'telos-mainnet' etc.

export interface StoredAccount {
  /** EOS on-chain account name (resolved from the key / chain) */
  name: string
  /** User-defined label in the app (not the EOS account name) */
  label?: string
  /** Encrypted private key (AES-GCM, base64 encoded with prefix) */
  encryptedKey: string
  /** Public key (WIF format) — stored unencrypted for display */
  publicKey: string
  /** Chain this account belongs to */
  network: NetworkId
  /** ISO timestamp when account was added */
  createdAt: string
  /** AtomicAssets asset id chosen as profile picture */
  avatarAssetId?: string
  /** Cached media URL for the avatar NFT */
  avatarUrl?: string
  /** Private key encrypted for quick unlock with PIN (AES-GCM, pw1.*) */
  pinEncryptedKey?: string
  /**
   * `legacy-password` — encryptedKey was encrypted with a user-chosen password (embedded / old imports).
   * `internal-random` — encryptedKey uses an auto-generated secret; PIN unlock via secure `internal_password_*`.
   */
  keyEncryption?: 'legacy-password' | 'internal-random'
}

/** Primary line for UI: `"My wallet (eosaccount)"` or `eosaccount` if no label. */
export function formatAccountDisplay(account: Pick<StoredAccount, 'name' | 'label'>): string {
  const name = account.name?.trim() ?? ''
  const label = account.label?.trim()
  if (label) return `${label} (${name})`
  return name
}

export interface UnlockedAccount {
  name: string
  privateKey: string
  publicKey: string
  network: NetworkId
}

export interface WalletState {
  accounts: StoredAccount[]
  activeAccountName: string | null
}
